<div class="workflow-pipeline">
  @for (step of steps(); track step.key; let last = $last) {
    <div class="step-wrapper" [class.last]="last">
      <button
        type="button"
        class="step-dot"
        [class]="'step-dot ' + getStatusClass(step.statusId)"
        [disabled]="!isStepClickable(step)"
        [class.step-clickable]="isStepClickable(step)"
        [class.step-locked]="step.locked"
        (click)="handleStepClick(step)"
        [attr.aria-label]="step.label | translate"
      >
        @if (getStepIcon(step)) {
          <mat-icon>{{ getStepIcon(step) }}</mat-icon>
        }
      </button>
      <span class="step-label">{{ step.label | translate }}</span>
    </div>
  }
</div>
